import { render, staticRenderFns } from "./GameStory.vue?vue&type=template&id=a46b0efa&scoped=true&"
import script from "./GameStory.vue?vue&type=script&lang=js&"
export * from "./GameStory.vue?vue&type=script&lang=js&"
import style0 from "./GameStory.vue?vue&type=style&index=0&id=a46b0efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46b0efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a46b0efa')) {
      api.createRecord('a46b0efa', component.options)
    } else {
      api.reload('a46b0efa', component.options)
    }
    module.hot.accept("./GameStory.vue?vue&type=template&id=a46b0efa&scoped=true&", function () {
      api.rerender('a46b0efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/GameStory.vue"
export default component.exports